import { VehiclesRestrictionValue } from '../../types'
import type { Texts } from '../useTexts'

export type Option = string[]

export const createValidateCourierFilterVehicles = (
  texts: Texts,
  vehicleIds: Option[],
  type: uui.domain.rm.RouteManagerUserType,
  restriction: VehiclesRestrictionValue,
) => {
  const noVehiclesAdded =
    restriction === 'restricted' && Array.isArray(vehicleIds) && vehicleIds.length === 0

  const courierFilterVehiclesRequiredErrors = {
    id: 'courierFilterVehicleErrors',
    message: noVehiclesAdded ? texts.errors.courierFilter.noVehicles : undefined,
  }

  const courierFilterVehiclesRequired = type === 'courier' && noVehiclesAdded

  return {
    [courierFilterVehiclesRequiredErrors.id]: courierFilterVehiclesRequired
      ? courierFilterVehiclesRequiredErrors
      : undefined,
  }
}
